export enum CastReportType {
  emergency = "emergency",
  contact = "contact",
  exit = "exit",
}
